import React from 'react'
import { Popup, Button } from 'components/UIElements'
import 'styles/d3/filter.scss'

export const _getMapState = key => state => {
  return {
    key,
    criteria: state.tableFilters.criteria[key] || null,
    filterApplied: state.tableFilters.filters.hasOwnProperty(key)
  }
}

export { actions as mapActions } from 'store/tableFilters'

class Filter extends React.Component {
  onSubmit = e => {
    e.preventDefault()
    this.applyFilter()
  }

  applyFilter = () => {
    this.setState({ _edited: false })
    this.props.setFilterCriteria(this.key, this.state)
    this.props.addFilter(this.key, this.getFilter(this.state))
  }

  removeFilter = () => {
    this.setState({ ...this.defaults })
    this.props.removeFilter(this.key)
  }

  cancelFilter = () => {
    this.setState({ ...(this.props.criteria || this.defaults), _edited: false })
  }

  render(content) {
    return (
      <Popup
        align={this.align}
        className='d3-filter-box'
        trigger={
          <i
            className={`fa fa-filter${
              this.props.filterApplied ? ' active' : ''
            }`}
          />
        }>
        <form onSubmit={this.onSubmit}>
          <div className='flexed space-between'>
            <h5>Filter</h5>
            <Button
              className='close-trigger'
              disabled={!this.props.filterApplied}
              link
              onClick={this.removeFilter}
              content='Clear'
              icon='fa fa-times'
            />
          </div>
          <p>{this.header}</p>
          <div>{content}</div>
          <div className='flexed end-justified'>
            <Button
              className='close-trigger'
              disabled={!this.state._edited}
              link
              onClick={this.cancelFilter}
              content='Cancel'
            />
            <Button
              type='submit'
              className='close-trigger'
              disabled={!this.state._edited}
              link
              content='Apply'
            />
          </div>
        </form>
      </Popup>
    )
  }
}

export default Filter
